import React from 'react';
import { useNavigate } from 'react-router-dom';
import HandymanIcon from '@mui/icons-material/Handyman';
import { 
  Drawer, 
  List, 
  ListItem, 
  ListItemIcon, 
  ListItemText,
  ListItemButton,
  Divider,
  Box,
  Typography,
  Collapse
} from '@mui/material';
import { useState } from 'react'; 
import { 
  Assignment as ProjectIcon,
  Search as SearchIcon,
  Settings as SettingsIcon,
  ExitToApp as LogoutIcon,
  Login as LoginIcon,
  Home as HomeIcon,  
  MenuBook as MenuBookIcon, 
  ExpandLess,                
  ExpandMore  
} from '@mui/icons-material';
import { signOut } from 'firebase/auth';
import { auth } from '../firebaseConfig';

const Sidebar = ({ user, onLoginClick }) => {
  const navigate = useNavigate();
  const [blogsOpen, setBlogsOpen] = useState(false); 
  const handleLogout = async () => {
    try {
      await signOut(auth);
      // Don't navigate after logout
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  const handleToggleBlogs = () => {
    setBlogsOpen(!blogsOpen);
  };

  const menuItems = [
    { text: 'Home', icon: <HomeIcon />, path: '/' },  // Add Home as first item
    { text: 'Projects', icon: <ProjectIcon />, path: '/projects' },
    { text: 'Personal Projects', icon: <ProjectIcon />, path: '/personal-projects' },
    { text: 'Search', icon: <SearchIcon />, path: '/search' },
    { text: 'Settings', icon: <SettingsIcon />, path: '/settings' },
     { text: 'DIY Tools', icon: <HandymanIcon />, path: '/tools' }
  ];

  return (
    <Drawer
      variant="permanent"
      sx={{
        width: 240,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width: 240,
          boxSizing: 'border-box',
          backgroundColor: '#e3f2fd',
          color: 'primary.dark',
          display: 'flex',
          flexDirection: 'column',
          height: '100%'
        },
      }}
    >
      <Box sx={{ p: 2 }}>
        <Typography 
          variant="h6" 
          component="div" 
          sx={{ 
            color: 'primary.dark',
            cursor: 'pointer',
            '&:hover': {
              opacity: 0.8
            }
          }}
          onClick={() => navigate('/')}  // Add click handler to logo
        >
          Project Dashboard
        </Typography>
      </Box>
      <Divider sx={{ backgroundColor: 'rgba(0,0,0,0.12)' }} />
      <List>
        {menuItems.map((item) => (
          <ListItem key={item.text} disablePadding>
            <ListItemButton
              onClick={() => navigate(item.path)}
              sx={{
                '&:hover': {
                  backgroundColor: 'rgba(0,0,0,0.08)',
                },
                // Highlight active route
                backgroundColor: window.location.pathname === item.path ? 'rgba(0,0,0,0.04)' : 'transparent'
              }}
            >
              <ListItemIcon sx={{ color: 'primary.dark' }}>
                {item.icon}
              </ListItemIcon>
              <ListItemText primary={item.text} />
            </ListItemButton>
          </ListItem>
        ))}
          {/* Add this new DIY Blogs section */}
  <ListItem disablePadding>
    <ListItemButton
      onClick={handleToggleBlogs}
      sx={{
        '&:hover': {
          backgroundColor: 'rgba(0,0,0,0.08)',
        },
      }}
    >
      <ListItemIcon sx={{ color: 'primary.dark' }}>
        <MenuBookIcon />
      </ListItemIcon>
      <ListItemText primary="DIY Blogs" />
      {blogsOpen ? <ExpandLess /> : <ExpandMore />}
    </ListItemButton>
  </ListItem>
  
<Collapse in={blogsOpen} timeout="auto" unmountOnExit>
  <List component="div" disablePadding>
    {user ? (
      <ListItemButton
        sx={{ pl: 4 }}
        onClick={() => navigate('/blogs')}
      >
        <ListItemIcon sx={{ color: 'primary.dark' }}>
          <MenuBookIcon />
        </ListItemIcon>
        <ListItemText primary="All Articles" />
      </ListItemButton>
    ) : (
      <ListItemButton
        sx={{ pl: 4 }}
        onClick={() => navigate('/public/blogs')}
      >
        <ListItemIcon sx={{ color: 'primary.dark' }}>
          <MenuBookIcon />
        </ListItemIcon>
        <ListItemText primary="Browse Articles" />
      </ListItemButton>
    )}
  </List>
</Collapse>
      </List>
      <Box sx={{ flexGrow: 1 }} />
      <Divider sx={{ backgroundColor: 'rgba(0,0,0,0.12)' }} />
      <List>
        <ListItem disablePadding>
          {user ? (
            <ListItemButton
              onClick={handleLogout}
              sx={{
                '&:hover': {
                  backgroundColor: 'rgba(0,0,0,0.08)',
                },
              }}
            >
              <ListItemIcon sx={{ color: 'primary.dark' }}>
                <LogoutIcon />
              </ListItemIcon>
              <ListItemText primary="Logout" />
            </ListItemButton>
          ) : (
            <ListItemButton
              onClick={onLoginClick}
              sx={{
                '&:hover': {
                  backgroundColor: 'rgba(0,0,0,0.08)',
                },
              }}
            >
              <ListItemIcon sx={{ color: 'primary.dark' }}>
                <LoginIcon />
              </ListItemIcon>
              <ListItemText primary="Login" />
            </ListItemButton>
          )}
        </ListItem>
      </List>
    </Drawer>
  );
};

export default Sidebar;

